export class BasicHierarchyModel {
  constructor(
    public id: number = null,
    public label: string = null,
    public idParents: number[] = []
  ) {}
}
